import { z } from 'zod';
/**
 * Champ texte optionnel : les chaînes vides renvoyées par les formulaires
 * sont normalisées en `undefined` (et non stockées comme "").
 */
export const optionalString = (max = 255) => z
    .string()
    .trim()
    .max(max)
    .optional()
    .or(z.literal(''))
    .transform((v) => (v === '' || v === undefined ? undefined : v));
/**
 * Entier optionnel : normalise chaîne vide / null en `undefined` AVANT coercion,
 * pour éviter qu'un champ numérique laissé vide devienne `0`.
 */
export const optionalInt = (opts) => z.preprocess((v) => (v === '' || v === null || v === undefined ? undefined : v), (() => {
    let n = z.coerce.number().int();
    if (opts?.min !== undefined)
        n = n.min(opts.min);
    if (opts?.max !== undefined)
        n = n.max(opts.max);
    return n.optional();
})());
/** Identifiant optionnel (chaîne vide → undefined). */
export const optionalId = () => z
    .string()
    .trim()
    .optional()
    .or(z.literal(''))
    .transform((v) => (v === '' || v === undefined ? undefined : v));
/** Email optionnel (vide → undefined). */
export const optionalEmail = () => z
    .string()
    .trim()
    .email('Email invalide')
    .optional()
    .or(z.literal(''))
    .transform((v) => (v === '' || v === undefined ? undefined : v));
//# sourceMappingURL=common.js.map